export default "__VITE_ASSET__CAaPQ7hn__"